module.exports = __webpack_public_path__ + "img/article-gb-dwrg-8.892f178f.jpg";